/* Zip Scanners | SC Product Options universal visual grouping.
   Required option fields are shown as "Included"; all remaining choices
   are shown as "Optional Extras". Selection, pricing, validation and checkout
   are entirely managed by SC. This script only changes CSS classes/headings. */
(function () {
  "use strict";

  var DEBOUNCE_MS = 100;
  var pending = false;
  var markerClass = "zs-sc-heading";
  var isProgrammingProductPage = /\/products\/police-scanner-programming(?:\/|$)/i.test(
    window.location.pathname
  );

  function textWithoutHelp(node) {
    if (!node) return "";
    var cloned = node.cloneNode(true);
    cloned.querySelectorAll(".bold_tooltip, .bold_help_text, .bold_option_value_price, script, style").forEach(function (n) { n.remove(); });
    return (cloned.textContent || "").replace(/\s+/g, " ").trim();
  }

  function nameOf(el) {
    return textWithoutHelp(el.querySelector(".bold_option_title")) ||
      textWithoutHelp(el.querySelector(".bold_option_value_title")) ||
      textWithoutHelp(el).slice(0, 160);
  }

  function required(el) {
    if (el.matches(".bold_option_required, [data-required='true'], [aria-required='true']")) return true;
    if (el.querySelector(".bold_option_required, input[required], textarea[required], select[required], [aria-required='true'], [data-required='true']")) return true;
    var title = el.querySelector(".bold_option_title");
    if (title && /\*\s*$/.test(textWithoutHelp(title))) return true;
    var choices = el.querySelectorAll(".bold_option_value_title");
    for (var i = 0; i < choices.length; i++) {
      if (/\*\s*$/.test(textWithoutHelp(choices[i]))) return true;
    }
    return !title && /\*\s*$/.test(nameOf(el));
  }

  function isShown(el) {
    return !el.hidden && el.getClientRects().length > 0;
  }

  function setClass(el, className, needed) {
    if (el.classList.contains(className) !== needed) el.classList.toggle(className, needed);
  }

  function decorateSet(set) {
    var all = Array.prototype.filter.call(set.querySelectorAll(".bold_option"), function (el) {
      return !el.parentElement.closest(".bold_option") &&
        !el.classList.contains("bold_option_displaytext");
    });
    var opts = all.filter(isShown);
    if (!opts.length) return false;
    var parent = opts[0].parentElement;
    if (!opts.every(function (el) {return el.parentElement === parent;})) return false;

    var groups = [];
    opts.forEach(function (el, index) {
      // On the standalone programming page, preserve SC's conditional
      // option layout without adding Included/Optional Extras styling.
      var kind = !isProgrammingProductPage && required(el) ? "included" : "optional";
      var previous = groups[groups.length - 1];
      if (!previous || previous.kind !== kind) {
        groups.push({kind:kind, first:el, last:el});
      } else {
        previous.last = el;
      }
      setClass(el, "zs-sc-included", kind === "included");
      setClass(el, "zs-sc-included--last", false);
      setClass(el, "zs-sc-vehicle", /will\s+you\s+use\s+(?:your\s+)?scanner\s+in\s+(?:a\s+)?vehicle/i.test(nameOf(el)));
    });

    // If a product has no required selections, keep Customize Order and
    // the normal SC fields. Do not add an unnecessary Optional Extras
    // heading or its separator line.
    if (!groups.some(function (g) { return g.kind === "included"; })) {
      groups = [];
    }
    groups.forEach(function (g) {
      if (g.kind === "included") setClass(g.last, "zs-sc-included--last", true);
    });

    // Reuse generated heading nodes. This avoids mutating/replacing SC fields
    // and prevents repeated DOM mutations when SC updates option prices.
    var headings = Array.prototype.filter.call(parent.children, function (el) {
      return el.classList.contains(markerClass);
    });
    groups.forEach(function (g, index) {
      var heading = headings[index];
      if (!heading) {
        heading = document.createElement("div");
        heading.setAttribute("role", "heading");
        heading.setAttribute("aria-level", "3");
      }
      var extra = g.kind === "optional";
      var targetClass = markerClass + " " + (extra ? "zs-sc-heading--optional" : "zs-sc-heading--included");
      if (heading.className !== targetClass) heading.className = targetClass;
      var targetText = extra ? "Optional Extras" : "Included";
      if (heading.textContent !== targetText) heading.textContent = targetText;
      if (heading.nextElementSibling !== g.first) parent.insertBefore(heading, g.first);
    });
    headings.slice(groups.length).forEach(function (el) {el.remove();});
    return true;
  }

  function decorate() {
    pending = false;
    document.querySelectorAll(".bold_options").forEach(function (container) {
      var sets = container.querySelectorAll(".bold_option_set");
      if (sets.length) {
        sets.forEach(decorateSet);
      } else {
        decorateSet(container);
      }
      // Universal presentation applies even if grouping is unavailable for
      // an unusual SC option-set layout.
      if (container.querySelector(".bold_option")) setClass(container, "zs-sc-global", true);
    });
  }

  function queue() {
    if (pending) return;
    pending = true;
    window.setTimeout(decorate, DEBOUNCE_MS);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", queue);
  else queue();

  // SC inserts fields asynchronously, including after opening Edit Options.
  var observer = new MutationObserver(queue);
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["style", "hidden", "aria-hidden"]
  });
  document.addEventListener("change", queue, true);
  document.addEventListener("click", queue, true);
})();